import React from 'react'
declare module 'react' {
  interface ImgHTMLAttributes<T> extends HTMLAttributes<T> {
    fetchpriority?: 'high' | 'low' | 'auto'
  }
}

const Logo = () => (
  <img
    width="222"
    height="40"
    style={{ width: '100%' }}
    src="/stanford-ackel-logo.svg"
    alt="Stanford & Ackel - Logo"
    fetchpriority="high"
  />
)

export default Logo
